/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { DataGrid, Grid, Table, Button } from '../../components/index';
import ModalPeriodo from './ModalPeriodo';
import ModalCalculadoraPeriodo from './ModalCalculadoraPeriodo';
import User from '../../domain/User';
import { trataMensagensErro } from '../../utils/requests';


const avisoDuplaDestinacao = {
  textAlign: 'left',
  fontWeight: '600',
  padding: '12px 10px 12px 10px',
  fontSize: '15px',
  marginLeft: '10px',
  flexGrow: '0',
  borderRadius: '5px',
  backgroundColor: '#e29402',
  color: 'white',
  height: '95px',
  verticalAlign: 'middle',
  marginBottom: '6px',
};

const avisoTempoRoRGPS = {
  textAlign: 'center',
    fontWeight: '500px',
    padding: '10px',
    fontSize: '14px',
    width: '550px',
    flexGrow: '0px',
    borderRadius: '5px',
    backgroundColor: 'rgb(223, 229, 232)',
    color: 'rgb(84, 110, 122)',
    verticalAlign: 'middle',
    position: 'relative',
    margin: '0px'
};

class MultiplosPeriodos extends Component {
  constructor() {
    super();
    const initialState = this.getInitialState();
    this.state = initialState;
  }

  getInitialState = () => ({
    periodo: {
      dataInicio: null,
      dataFim: null,
      qtdDiasContribuicaoBruto: null,
      qtdDiasDesconto: 0,
      qtdDiasContribuicaoLiquido: null,
      operacao: 0,
    },
    lista: [],
    showModal: false,
    showModalCalculadoraPeriodo: false,
  })

  mensagemDuplaDestinacao = () => {
    const mensagem1 = (<p>CTC encontrada possui dois destinatários.</p>);
    const mensagem2 = (<p>É necessário o ajuste somente no(s) período(s) destinado(s) e aproveitado(s) no RPPS Solicitante, devendo excluir o(s) período(s) destinado(s) ao outro Ente Federativo/RPPS.</p>);
    return (
      <React.Fragment>
        {mensagem1}
        {mensagem2}
      </React.Fragment>
    );
  }

  msgExplicativaTempoRoRGPS = () => {
    const mensagem1 = (<p style={avisoTempoRoRGPS}>
      Na relação entre RGPS e RPPS, aplica-se a fórmula de cálculo utilizada pelo RGPS.<br></br>
      Caso deseje confirmar, utilize o botão da calculadora para conferência do tempo RO.
    </p>);

    return (
      <React.Fragment>
        {mensagem1}
      </React.Fragment>
    );
  }

  showModal = () => {
    const { requerimento } = { ...this.props.estadoFormulario }
    if (requerimento.destinatario && requerimento.destinatario !== null && requerimento.destinatario !== '') {
      const periodoNew = {
        dataInicio: null,
        dataFim: null,
        qtdDiasContribuicaoBruto: null,
        qtdDiasDesconto: 0,
        qtdDiasContribuicaoLiquido: null,
        operacao: 1,
      };
      this.setState({ periodo: periodoNew, showModal: !this.state.showModal });
    } else {
      trataMensagensErro([`Destinatário da compensação não informado. Informe o destinatário.`]);
    }
  }

  showModalAlterar = () => {
    const { requerimento } = { ...this.props.estadoFormulario }
    if (requerimento.destinatario && requerimento.destinatario !== null && requerimento.destinatario !== '') {
        this.setState({ showModal: !this.state.showModal });
    } else {
      trataMensagensErro([`Destinatário da compensação não informado. Informe o destinatário.`]);
    } 
  }

  showModalCalculadoraPeriodo = () => {
    this.setState({ showModalCalculadoraPeriodo: !this.state.showModalCalculadoraPeriodo });
  }

  deleteItem = (row) => {
    const { requerimentoPeriodos } = { ...this.props.estadoFormulario.requerimento };
    const { requerimentoPeriodosExcluidos } = { ...this.props.estadoFormulario.requerimento };
    const periodoExcluir = {
      idPeriodo: requerimentoPeriodos[row] ? requerimentoPeriodos[row].idPeriodo : null,
      dataInicio: requerimentoPeriodos[row] ? requerimentoPeriodos[row].dataInicio : null,
      dataFim: requerimentoPeriodos[row] ? requerimentoPeriodos[row].dataFim : null,
      qtdDiasContribuicaoBruto: requerimentoPeriodos[row] ? requerimentoPeriodos[row].qtdDiasContribuicaoBruto : null,
      qtdDiasDesconto: requerimentoPeriodos[row] ? requerimentoPeriodos[row].qtdDiasDesconto : null,
      qtdDiasContribuicaoLiquido: requerimentoPeriodos[row] ? requerimentoPeriodos[row].qtdDiasContribuicaoLiquido : null,
      indice: requerimentoPeriodos[row] ? requerimentoPeriodos[row].indice : null,
      operacao: 3,
    };
    if (requerimentoPeriodos[row].idPeriodo) {
      requerimentoPeriodosExcluidos.push(periodoExcluir);
    }
    this.setState({ periodo: periodoExcluir });
    requerimentoPeriodos.splice(row, 1);
    this.alteraListaAposExclusao(requerimentoPeriodos, requerimentoPeriodosExcluidos, 3);
  }
  verificarOperacao = (periodo) => {
    const { acao } = { ...this.props.estadoFormulario };
    return (['cumprir-exigencia', 'indeferidos'].includes(acao) && !periodo.idPeriodo) ||
    (['complementar-aposentadoria'].includes(acao) && !periodo.idPeriodo) ||
    (['novo'].includes(acao) && !periodo.idPeriodo);
  }

  alterarItem = (row) => {
    const { requerimentoPeriodos } = { ...this.props.estadoFormulario.requerimento };
    const periodoAlterar = {
      idPeriodo: requerimentoPeriodos[row] ? requerimentoPeriodos[row].idPeriodo : null,
      dataInicio: requerimentoPeriodos[row] ? requerimentoPeriodos[row].dataInicio : null,
      dataFim: requerimentoPeriodos[row] ? requerimentoPeriodos[row].dataFim : null,
      qtdDiasContribuicaoBruto: requerimentoPeriodos[row] ? requerimentoPeriodos[row].qtdDiasContribuicaoBruto : null,
      qtdDiasDesconto: requerimentoPeriodos[row] ? requerimentoPeriodos[row].qtdDiasDesconto : null,
      qtdDiasContribuicaoLiquido: requerimentoPeriodos[row] ? requerimentoPeriodos[row].qtdDiasContribuicaoLiquido : null,
      indice: requerimentoPeriodos[row] ? requerimentoPeriodos[row].indice : null,
      // operacao: this.verificarOperacao(requerimentoPeriodos[row]) ? 2 : null,
      operacao: 2,
    };
    this.setState({ periodo: periodoAlterar });
    this.showModalAlterar();
  }
  createActionColumn = index => (
    <React.Fragment>
      {this.exibirBotaoAlterar() &&
        <Button
          hint="Alterar"
          icon="ico-pencil"
          mini
          onClick={() => this.alterarItem(index)}
        />
      }
      {this.exibirBotoesPadrao() &&
        <Button
          className="dtp-inverse"
          hint="Excluir"
          icon="ico-hourglass-minus"
          mini
          onClick={() => this.deleteItem(index)}
        />
      }
    </React.Fragment>
  );
  createCustomInsertButton = () => (
    <React.Fragment>
      {!['realizar-analise', 'consulta', 'qualificar'].includes(this.props.estadoFormulario.acao) &&
        <Button
          // disabled={((!this.props.estadoFormulario.requerimento.inexistenciaCtc) && (!this.props.estadoFormulario.pesquisarProtocoloCertidao))}
          onClick={() => this.showModal()}
          hint="incluir período"
          icon="ico-hourglass-plus"
        />
      }
      {this.verificaRgpsNaRelacao() ? 
        <Button 
          onClick={() => this.showModalCalculadoraPeriodo()}
          hint="calculadora de períodos"
          icon="ico-calc"
        />
      : ''}
      {this.verificaRgpsNaRelacao() &&
        <div style={{ position: 'relative', top: '-68px',left: '180px', height: '0px'}}>
          {this.msgExplicativaTempoRoRGPS()}
        </div>
      }  
    </React.Fragment> 
  );

  options = {
    hideSizePerPage: true,
    insertBtn: this.createCustomInsertButton,
    noDataText: 'Nenhum período foi adicionado à lista',
    sizePerPage: 5,
  };

  fetchInfo = {};
  handleChange = (changeObj, name) => {
    const { periodo } = { ...this.state };
    let valor = changeObj.value;
    if (name === 'qtdDiasDesconto' && valor === '') {
      valor = 0;
    }
    this.setState({
      periodo: {
        ...periodo,
        [name]: valor,
      },
    });
  }

  atualizarTempos = (tempoBruto, tempoLiquido) => {
    const { periodo } = { ...this.state };
    this.setState({
      periodo: {
        ...periodo,
        qtdDiasContribuicaoBruto: tempoBruto,
        qtdDiasContribuicaoLiquido: tempoLiquido,
      },
    });
  }

  atualizarTempoContribuicaoLiquido = (tempoLiquido) => {
    const { periodo } = { ...this.state };
    this.setState({
      periodo: {
        ...periodo,
        qtdDiasContribuicaoLiquido: tempoLiquido,
      },
    });
  }
  // alteraListaAposExclusao = (listaPeriodos, origem) => {
  alteraListaAposExclusao = (listaPeriodos, listaPeriodosExclusao, origem) => {
    this.props.handleChange({ value: listaPeriodos, isValid: listaPeriodos.length > 0 },'requerimentoPeriodos');
    this.props.handleChange({ value: listaPeriodosExclusao, isValid: listaPeriodosExclusao.length > 0 },'requerimentoPeriodosExcluidos');
    this.props.atualizarDataIngressoDesvinculacaoETempo(listaPeriodos, origem);
  }
  montaTableHeader = () => {
    const tableHeader = [
      {
        id: 'dataInicio',
        label: 'Data de Início',
      },
      {
        id: 'dataFim',
        label: 'Data de Término',
      },
      {
        id: 'qtdDiasContribuicaoBruto',
        label: 'Tempo de Contribuição Bruto',
      },
      {
        id: 'qtdDiasDesconto',
        label: 'Tempo Descontado',
      },
      {
        id: 'qtdDiasContribuicaoLiquido',
        label: 'Tempo de Contribuição Líquido',
      },
    ];
    if (!['realizar-analise', 'consulta', 'qualificar'].includes(this.props.estadoFormulario.acao)) {
      tableHeader.push({
        id: 'indice',
        label: 'Ação',
        dataFormat: this.createActionColumn,
      });
    }
    return tableHeader;
  }

  exibirBotaoAlterar = () => (
    (this.props.estadoFormulario !== 'criado' && ['novo', 'cumprir-exigencia', 'indeferidos', 'complementar-aposentadoria'].includes(this.props.estadoFormulario.acao))
  );

  exibirBotoesPadrao = () => (
    (this.props.estadoFormulario !== 'criado' && ['novo', 'cumprir-exigencia', 'indeferidos', 'complementar-aposentadoria'].includes(this.props.estadoFormulario.acao))
  );

  exibirBotoesTableHeader = () => {
    let retorno = false;
    if (this.props.estadoFormulario !== 'criado' && ['novo', 'cumprir-exigencia', 'indeferidos', 'complementar-aposentadoria'].includes(this.props.estadoFormulario.acao)) {
      retorno = true;
    } else if (['realizar-analise', 'consulta'].includes(this.props.estadoFormulario.acao) && this.verificaRgpsNaRelacao()) {
      retorno = true;
    } 
    return retorno;
  }

  calcularTempoDeContribuicaoBruto = (periodo) => {
    const { estadoFormulario } = { ... this.props };
    if (periodo) {
      if ((periodo.dataInicio && periodo.dataInicio.indexOf('_') === -1) &&
        (periodo.dataFim && periodo.dataFim.indexOf('_') === -1)) {

        if ((estadoFormulario.requerimento.destinatario && estadoFormulario.requerimento.destinatario === '01000') || 
          (this.props.estadoFormulario.requerimento.destinatario && this.props.estadoFormulario.requerimento.destinatario.codigo === '01000') || 
          (User.logged().isRGPS()) ||
          (this.props.estadoFormulario.requerimento.solicitante && this.props.estadoFormulario.requerimento.solicitante.codigo === '01000'))  {
          return this.props.calcularPeriodoRgps(periodo, false);
        } else {
          return this.props.calcularPeriodoRpps(periodo);
        }
      }
    }
    return 0;
  }

  calcularTempoDeContribuicaoLiquido = (periodo) => {
    if (periodo) {
      const qtdDiasDesconto = periodo.qtdDiasDesconto ? Number(periodo.qtdDiasDesconto): 0;
      const tempoBruto = periodo.qtdDiasContribuicaoBruto ? Number(periodo.qtdDiasContribuicaoBruto) : 0;
      const retorno = Math.trunc((tempoBruto - qtdDiasDesconto));
      return retorno;
    }
    return 0;
  }

  verificaRgpsNaRelacao = () => {
    const { estadoFormulario } = { ... this.props };
    if ((estadoFormulario.requerimento.destinatario && estadoFormulario.requerimento.destinatario === '01000') || 
        (this.props.estadoFormulario.requerimento.destinatario && this.props.estadoFormulario.requerimento.destinatario.codigo === '01000') || 
        (User.logged().isRGPS()) ||
        (this.props.estadoFormulario.requerimento.solicitante && this.props.estadoFormulario.requerimento.solicitante.codigo === '01000'))  {
          return true;
    }
    return false;
  }

  render() {
    let lista = [];
    if(this.props.estadoFormulario.requerimento.requerimentoPeriodos) {
      lista = this.props.estadoFormulario.requerimento.requerimentoPeriodos;
    }
    const listaIndexada = lista.map((item, i) => {
      const itemIndexado = item;
      itemIndexado.indice = i;
      itemIndexado.qtdDiasContribuicaoBruto = this.calcularTempoDeContribuicaoBruto(itemIndexado);
      itemIndexado.qtdDiasContribuicaoLiquido = this.calcularTempoDeContribuicaoLiquido(itemIndexado);
      itemIndexado.qtdDiasDesconto = itemIndexado.qtdDiasDesconto ? itemIndexado.qtdDiasDesconto : 0;
      return itemIndexado;
    });
    return (
      <React.Fragment>
        <DataGrid title="Períodos" icon="ico-hourglass">
          <div className="row">
            <Grid cols="12 12 12 12">
              {this.props.estadoFormulario.duplaDestinacao &&
                <div style={avisoDuplaDestinacao}>
                  {this.mensagemDuplaDestinacao()}
                </div>
              }
              <Table
                bordered
                data={this.props.ordenarListaPeriodos(listaIndexada)}
                insertRow={this.exibirBotoesTableHeader()}
                options={this.options}
                listaTableHeader={this.montaTableHeader()}
                pagination
                fetchInfo={this.fetchInfo}
              />
            </Grid>
          </div>
        </DataGrid>
        { this.state.showModal ? (
          <ModalPeriodo
            {...this.props}
            periodo={this.state.periodo}
            handleModal={() => this.showModal('showModal')}
            handleChangePeriodos={this.handleChange}
            handleChange={this.props.handleChange}
            showModal={this.state.showModal}
            atualizarDataIngressoDesvinculacaoETempo={this.props.atualizarDataIngressoDesvinculacaoETempo}
            atualizarTempos={this.atualizarTempos}
            atualizarTempoContribuicaoLiquido={this.atualizarTempoContribuicaoLiquido}
            determinarConcomitancias={this.props.determinarConcomitancias}
            ordenarListaPeriodos={this.props.ordenarListaPeriodos}
            calcularPeriodoRgps={this.props.calcularPeriodoRgps}
            calcularPeriodoRpps={this.props.calcularPeriodoRpps}
          />
        ) : ''}
          { this.state.showModalCalculadoraPeriodo ? (
          <ModalCalculadoraPeriodo
            {...this.props}
            handleModal={() => this.showModalCalculadoraPeriodo('showModalCalculadoraPeriodo')}
            showModal={this.state.showModalCalculadoraPeriodo}
            estadoFormulario={this.props.estadoFormulario}
          />
        ) : ''}
      </React.Fragment>
    );
  }
}

MultiplosPeriodos.propTypes = {
  handleChange: PropTypes.func.isRequired,
  estadoFormulario: PropTypes.objectOf(PropTypes.object).isRequired,
  atualizarDataIngressoDesvinculacaoETempo: PropTypes.func.isRequired,
  determinarConcomitancias: PropTypes.func.isRequired,
  ordenarListaPeriodos: PropTypes.func.isRequired,
  calcularPeriodoRgps: PropTypes.func.isRequired,
  calcularPeriodoRpps: PropTypes.func.isRequired,
};
export default (MultiplosPeriodos);



// WEBPACK FOOTER //
// ./src/pages/requerimentos/MultiplosPeriodos.jsx